import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  SHOP_HERO_IMAGE_BLOCK_DATA_SOURCE,
  ShopHeroImageBlockDataSource,
} from './shop-hero-image-block-view-model';
import { ShopHeroImageBlockPreviewDataSource } from './shop-hero-image-block-preview-data-source';
import { ShopHeroImageBlockStoreDataSource } from './shop-hero-image-block-store-data-source';

export function provideShopHeroImageBlockDataSource(): Provider[] {
  return [
    ShopHeroImageBlockStoreDataSource,
    ShopHeroImageBlockPreviewDataSource,
    {
      provide: SHOP_HERO_IMAGE_BLOCK_DATA_SOURCE,
      useFactory: (): ShopHeroImageBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(ShopHeroImageBlockPreviewDataSource)
          : inject(ShopHeroImageBlockStoreDataSource);
      },
    },
  ];
}
